export const EDGE_SPACING = 38;
export const EDGE_SPACING_MED = 16;
export const COLLECTIONS_BUTTON_WIDTH = 270;
export const BUTTON_SPACING = 15;
